import { useCallback, useEffect, useMemo } from 'react';
import { useTable, useTableActions } from '../TableContext';

/**
 * Hook pour gérer la pagination facilement
 */
export const useTablePagination = () => {
  const { state } = useTable();
  const { setCurrentPage, setPageSize } = useTableActions();

  const goToFirstPage = useCallback(() => {
    setCurrentPage(1);
  }, [setCurrentPage]);

  const goToLastPage = useCallback(() => {
    setCurrentPage(state.totalPages);
  }, [setCurrentPage, state.totalPages]);

  const goToNextPage = useCallback(() => {
    if (state.currentPage < state.totalPages) {
      setCurrentPage(state.currentPage + 1);
    }
  }, [setCurrentPage, state.currentPage, state.totalPages]);

  const goToPreviousPage = useCallback(() => {
    if (state.currentPage > 1) {
      setCurrentPage(state.currentPage - 1);
    }
  }, [setCurrentPage, state.currentPage]);

  const canGoNext = state.currentPage < state.totalPages;
  const canGoPrevious = state.currentPage > 1;

  return {
    currentPage: state.currentPage,
    totalPages: state.totalPages,
    pageSize: state.pageSize,
    totalItems: state.totalItems,
    goToFirstPage,
    goToLastPage,
    goToNextPage,
    goToPreviousPage,
    setCurrentPage,
    setPageSize,
    canGoNext,
    canGoPrevious
  };
};
